module.exports = __webpack_public_path__ + "static/commission-headline-f644110a7f9656619b0617b5ba521750.jpg";